export default "__VITE_ASSET__CnhwgHgO__"